import { Signal } from '@modules';

/**
 * AttributesImport component constants
 * @returns {variables}
 */

export const SIGNAL_TYPES: Signal['type'][] = ['textual', 'numeric'];
